<template>
  <div :class="classes">
    <a href="#" class="vid-img" @click.prevent="$emit(`change-video`, item.id)">
      <img :src="imgUrl" :alt="item.pagetitle" class="video-img" />
      <div class="watched-badge is-overlay" v-if="waswatched">
        <i class="mdi mdi-check-circle"></i>
      </div>
    </a>
    <div class="play-icon">
      <a href="#" @click.prevent="$emit(`change-video`, item.id)">
        <img
          :src="
            this.$store.state.initialData.basepath +
            'assets/yoga/images/play-icon.png'
          "
          v-if="!waswatched"
        />
      </a>
    </div>
    <h4>{{ item.pagetitle }}</h4>
    <h5>
      <current-tag
        :current="getCurrent"
        :base="this.$store.state.initialData.basepath"
      >
      </current-tag>
      <teacher-tag
        :teacher="getTeacher"
        v-if="getTeacher"
        :base="this.$store.state.initialData.basepath"
      >
      </teacher-tag>
    </h5>
    <p class="desc" v-html="abstract"></p>
    <p class="bottom" v-if="level">
      {{ item.videoDuration }} דק’ | רמה: {{ level.label }}
    </p>
  </div>
</template>

<script>
import TeacherTag from "@/components/TeacherTag.vue";
import CurrentTag from "@/components/CurrentTag.vue";

export default {
  name: `SeriesVideoitem`,

  props: {
    item: Object,
    watched: Array,
    current: String,
  },
  components: {
    CurrentTag,
    TeacherTag,
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.ch;
    },
    getCurrent() {
      if (Array.isArray(this.$store.state.currents)) {
        const arr = this.$store.state.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.item.current
          ) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    },
    getTeacher() {
      if (Array.isArray(this.$store.state.initialData.teachers)) {
        const arr = this.$store.state.initialData.teachers.filter(t => {
          if (t.id === this.item.videoTeacher) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    },
    level() {
      const arr = this.$store.state.initialData.levels.filter(l => {
        if (l.value === this.item.videoLvl) {
          return true;
        }
        return false;
      });
      return arr[0];
    },

    abstract() {
      const str = this.item.description;
      if (str.length > 150) {
        return `${str.slice(0, 150)}...`;
      }
      return str;
    },

    waswatched() {
      if (this.watched.includes(`${this.item.id}`)) {
        return true;
      }
      return false;
    },

    classes() {
      if (this.current === `${this.item.id}`) {
        return `video-item series-video-item video-item-active`;
      }
      return `video-item series-video-item`;
    },
  },
};
</script>

<style lang="scss">
$overlayBg: rgba(101, 107, 133, 0.7);
$white: #ffffff;
$crimsonish: #976177;
$purple: #656b85;

.play-icon {
  a {
    display: block;
    img {
      opacity: 0.7;
    }
  }
}

.video-item {
  margin-bottom: 30px;
  h4 {
    padding: 10px;
    min-height: 75px;
  }
  p.desc {
    padding: 0 10px;
    margin-bottom: 10px;
    min-height: 120px;
  }
}

.series-video-item {
  position: relative;

  .watched-badge {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: $overlayBg;
    color: $white;
    padding-top: 3rem;

    .mdi {
      color: $white;
      font-size: 3.5rem;
    }
  }

  .vid-img {
    display: block;
    position: relative;
  }
}

.video-item-active {
  box-shadow: 0 0 10px 0 $purple;
  .play-icon {
    img {
      filter: drop-shadow(0px 0px 10px $purple);
    }
  }
  .video-img {
    filter: saturate(150%);
  }
}
</style>
